import React, { useContext } from 'react';
import { number, oneOfType, string } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Product } from './Product';

export const ProductContainer = ({ pipTimeout, ...props }) => {
  const store = useStore();
  const { storeId, storeZip } = store;

  const pipQueryOptions = ({ options, queryName }) => {
    if (queryName === 'product') {
      let to = 3000;
      if (pipTimeout) {
        if (typeof pipTimeout === 'string') {
          to = parseInt(pipTimeout, 10);
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(to)) {
            to = 3000;
          }
        } else if (typeof pipTimeout === 'number') {
          to = pipTimeout;
        }
      }
      return {
        ...options,
        context: {
          ...(options.context || {}),
          timeout: to
        }
      };
    }
    return options;
  };

  const merge = {
    productClientOnlyProduct: {
      queries: ['product', 'clientOnlyProduct'],
      fn: ({ query, mounted }) => {
        if (!mounted) return query;
        if (query === 'product' || query === 'clientOnlyProduct') {
          return 'productClientOnlyProduct';
        }
        return query;
      }
    }
  };
  const pipDefaultVariables = {
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    maxItems: 6,
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1,
    storeId,
    zipCode: storeZip
  };

  return (
    <QueryProvider
      cacheKey="product-page"
      defaultVariables={pipDefaultVariables}
      merge={merge}
      queryOptions={pipQueryOptions}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Product {...props} />
    </QueryProvider>
  );
};

ProductContainer.propTypes = {
  pipTimeout: oneOfType([string, number])
};

ProductContainer.defaultProps = {
  pipTimeout: '3000'
};

ProductContainer.displayName = 'ProductContainer';
